export const truncate = (str, length) => {
    // We multiply by two because the length is how many characters are on each side of the `...`
    if ((str?.length ?? 0) <= length * 2) {
        return str;
    }
    return `${str.slice(0, length)}...${str.slice(str.length - length, str.length)}`;
};
//# sourceMappingURL=truncate.js.map